import script from "./Pagination.vue?vue&type=script&setup=true&lang=ts&name=Pagination"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=ts&name=Pagination"

import "./Pagination.vue?vue&type=style&index=0&id=7c7b2c2e&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7b2c2e"]])

export default __exports__